import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
/**
 * Generated class for the SafeHtmlPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */

   constructor(private sanitizer:DomSanitizer) {

   }

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/safe-html/safe-html.ts